module.exports = __webpack_public_path__ + "static/media/RadwegSperreLangenrohr.104eff53.webp";